<template>
  <div class="wrapper">
    <div
      style="backgroundImage: url(./img/wixbackground.png); background-size: cover; min-height: 93vh"
    >
      <NavbarBlack />

      <div class="md-layout">
        <div
          class="md-layout-item md-size-100 md-small-100"
          style="height: 240px"
        >
          <br />
          <br />
        </div>
        <div class="md-layout-item md-size-35 md-small-hide"></div>
        <div
          class="md-layout-item md-size-30 md-small-size-100"
          style="text-align: center; background-color: white; padding: 0 70px 50px 60px;"
        >
          <div style="text-align: center">
            <div
              slot="title"
              class="title"
              style="font-family: 'Roboto'; color:black;font-size: xx-large;padding-top: 30px;"
            >
              {{ $t("Forgot Password") }}
            </div>
            <h4
              slot="title"
              class="title"
              style="font-family: 'Roboto'; color:darkslateblue"
            >
              {{ $t("Password Reset") }}
            </h4>
          </div>
          <br />
          <md-field
            class="md-form-group"
            slot="inputs"
            :class="[
              { 'md-valid': !errors.has('email') && touched.email },
              { 'md-error': errors.has('email') }
            ]"
          >
            <md-icon>email</md-icon>
            <label>{{ $t("Email") }}</label>
            <md-input
              name="email"
              data-vv-name="email"
              v-model="email"
              required
              v-validate="'required|email'"
              type="email"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('email')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('email') && touched.email"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
          <md-field
            class="md-form-group"
            slot="inputs"
            :class="[
              {
                'md-valid': !errors.has('password') && touched.password
              },
              { 'md-error': errors.has('password') }
            ]"
          >
            <md-icon>lock_outline</md-icon>
            <label>{{ $t("New Password") }}</label>
            <md-input
              name="password"
              data-vv-name="password"
              v-model="password"
              required
              v-validate="'required|min:8|verify_password'"
              type="password"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('password')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('password') && touched.password"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
          <p
            slot="inputs"
            v-show="errors.has('password')"
            class="help is-danger"
          >
            {{ errors.first("password") }}
          </p>
          <md-field
            md-field
            class="md-form-group"
            slot="inputs"
            :class="[
              {
                'md-valid':
                  !errors.has('confirmPassword') && touched.confirmPassword
              },
              { 'md-error': errors.has('confirmPassword') }
            ]"
          >
            <md-icon>lock_outline</md-icon>
            <label>{{ $t("Confirm Password") }}</label>
            <md-input
              name="confirmPassword"
              data-vv-name="confirmPassword"
              v-model="confirmPassword"
              required
              v-validate="{ required: true, is: password }"
              type="password"
            ></md-input>
            <slide-y-down-transition>
              <md-icon class="error" v-show="errors.has('confirmPassword')"
                >close</md-icon
              >
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon
                class="success"
                v-show="!errors.has('confirmPassword') && touched.password"
                >done</md-icon
              >
            </slide-y-down-transition>
          </md-field>
          <md-button
            slot="footer"
            class="md-primary md-block"
            @click="resetPassword"
            :disabled="errors.any()"
            >{{ $t("Submit") }}</md-button
          >
          <label v-if="errorMsg" class="mt-4 text-danger">
            {{ $t(errorMsg) }}
          </label>
        </div>
        <div class="md-layout-item md-size-35 md-small-hide" />
      </div>
    </div>
    <md-dialog-alert
      :md-active.sync="showSuccessTips"
      :md-content="
        $t(
          'Check your email for a confirmation link to activate your new password'
        )
      "
      :md-confirm-text="$t('Close')"
      @md-closed="onResetSuccess"
    ></md-dialog-alert>
    <FooterBlack />
  </div>
</template>
<script>
import FooterBlack from "./Layout/FooterBlack.vue";
import NavbarBlack from "./Layout/NavbarBlack.vue";
import { EventBus } from "@/helpers";
import { SlideYDownTransition } from "vue2-transitions";
import { router } from "@/main";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: {
    FooterBlack,
    NavbarBlack,
    SlideYDownTransition
  },
  name: "forgotpasswords",
  bodyClass: "index-page",
  props: {
    logoImg: {
      type: String,
      default: "./img/logo-inverted.png"
    },
    img: {
      type: String,
      default: "./img/default-avatar.png"
    }
  },
  data() {
    return {
      email: null,
      password: null,
      errorMsg: "",
      scrollPosition: null,
      mobilescreen: false,
      confirmPassword: "",
      touched: {
        password: false,
        confirmPassword: false
      },
      showSuccessTips: false
    };
  },
  computed: {
    setHeaderBgImage() {
      return {
        backgroundImage: `url(./img/background2x2.jpg)`
      };
    },
    setContactUsBgImage() {
      return {
        backgroundImage: `url(./img/bg-contactus.jpg)`
      };
    }
  },
  methods: {
    leafActive() {
      this.leafShow = window.innerWidth >= 768;
    },
    keymonitor(event) {
      if (event.key === "Enter") {
        this.logon();
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    async resetPassword() {
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        return;
      }

      const response = await this.$store.dispatch("auth/forgotPassword", {
        email: this.email,
        password: this.password
      });

      if (response === "success") {
        this.showSuccessTips = true;
      } else if (response === "unactivated") {
        this.errorMsg = this.$t("Account is not activated");
      }
    },
    onResetSuccess() {
      router.push("/login");
    },
    onResponsiveInverted() {
      this.mobilescreen = window.innerWidth < 800;
    }
  },
  mounted() {
    this.leafActive();
    window.addEventListener("resize", this.leafActive);
    document.addEventListener("scroll", this.updateScroll);
    EventBus.$on("failedLogon", msg => {
      this.errorMsg = msg;
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.leafActive);
    document.removeEventListener("scroll", this.updateScroll);
    EventBus.$off("failedLogon");
  },
  watch: {
    email() {
      this.errorMsg = "";
    },
    password() {
      this.touched.password = true;
      this.errorMsg = "";
    },
    confirmPassword() {
      this.touched.confirmPassword = true;
      this.errorMsg = "";
    }
  }
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

.vertical-nav-active {
  display: block;
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
@media all and (max-width: 768px) {
  .vertical-nav-active {
    display: none;
  }
}

.mb-0 {
  padding-bottom: 0 !important;
}

#morphing-cards {
  padding-top: 70px;
}

.cd-section {
  height: 100vh;
}
.md-toolbar {
  background-color: rgba(0, 0, 0, 0.5);
}
.main-toolbar {
  position: fixed;
  z-index: 1000;
  left: 0;
  right: 0;
}
@media all and (min-width: 991px) {
  .hamburger {
    display: none;
  }
}
@media all and (max-width: 768px) {
  .main-toolbar {
    background-color: white;
  }
}
</style>
